export enum MfaChallengeScreenNames {
  SELECT_MFA = 'Select MFA',
  VERIFY_OTP = 'Verify OTP in MFA',
  VERIFY_TOTP = 'Verify TOTP',
  TRUST_DEVICE = 'Trust Device?',
}

export type MfaChallengeScreenName =
  (typeof MFA_CHALLENGE_CUSTOM_SCREEN_NAMES)[number];

export const MFA_CHALLENGE_SCREEN_IDS = {
  SELECT_MFA: 'SC32Xe7yOBwp02agYx4EB8MPHcV2O',
  VERIFY_OTP: 'SC32Xe7vVTxm92G3PMj8KoFGEpSDP',
  VERIFY_TOTP: 'SC32Xe7vU7N5QT8kBEPSTkfjGe0M2',
  TRUST_DEVICE: 'SC32aJBCuXFdrs3x8EOI5fh4YARcY',
} as const;

export const MFA_CHALLENGE_CUSTOM_SCREEN_NAMES = [
  MfaChallengeScreenNames.SELECT_MFA,
  MfaChallengeScreenNames.VERIFY_OTP,
  MfaChallengeScreenNames.VERIFY_TOTP,
  MfaChallengeScreenNames.TRUST_DEVICE,
] as const;

export const isMfaChallengeScreen = (
  screenName: string
): screenName is MfaChallengeScreenName =>
  MFA_CHALLENGE_CUSTOM_SCREEN_NAMES.includes(
    screenName as MfaChallengeScreenName
  );
